import React from "react";

const NotFound = () => {
  return (
    <div className='flex items-center justify-center w-screen h-screen'>
      <div className='text-5xl font-bold px-10 border-r border-r-white'>
        404
      </div>
      <div className='px-10 font-bold'>Page not found</div>
    </div>
  );
};

export default NotFound;
